module.exports = __webpack_public_path__ + "front/img/b26_4.f713208c.jpg";